// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f8e4a30","239":"bc008d96","365":"c6479d7a","453":"3ac26dee","455":"ae069d16"}[chunkId] + ".chunk.js";
};